module.exports = __webpack_public_path__ + "img/Group_26970.53d3f824.svg";